gsap.registerPlugin(ScrollTrigger);
// GLOBAL
function coHandleStickyOnScroll(selector) {
  let lastScroll = window.scrollY;
  const el = document.querySelector(selector);
  if (!el) return;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll < lastScroll) {
      el.classList.add('co-sticky');
    } else {
      el.classList.remove('co-sticky');
    }
    lastScroll = currentScroll;
  });
}
coHandleStickyOnScroll('.co-about-5-media-wrapper');
// ============================================================================== SECTION 4
// if (!document.documentElement.classList.contains('shopify-design-mode')) {  }
document.querySelectorAll('.co-about-4-slide-frame-2').forEach((slide, i) => {
  gsap.to(slide, {
    scrollTrigger: {
      // markers: true,
      trigger: slide,
      start: "bottom bottom-=25%",
      end: "bottom+=75% top",
      scrub: 1
    },
    yPercent: -25
  });
});
document.querySelectorAll('.co-about-4-slide-frame-3').forEach((slide, i) => {
  gsap.to(slide, {
    scrollTrigger: {
      // markers: true,
      trigger: slide,
      start: "bottom bottom-=25%",
      end: "bottom+=50% top",
      scrub: 1
    },
    scale: 0.25,
    // opacity: 0
  });
});
// ============================================================================== SECTION 5
// Global Multi-Set Tab System - works across the entire document
(function() {
  // Configuration variables - customize these as needed
  const NAV_SET_CLASS = '[class*="co-about-5-nav-set-"]';
  const CONTENT_SET_CLASS = '[class*="co-about-5-content-set-"]';
  const NAV_ITEM_CLASS = '.co-about-5-nav-item';
  const CONTENT_ITEM_CLASS = '.co-about-5-content-item';
  const ACTIVE_CLASS = 'active';
  
  // Autoplay configuration
  const autoplayEnabled = false; 
  const autoplayDelay = 3000;
  const pauseOnInteraction = true;
  const pauseOnInteractionDelay = 3000;
  
  // Find ALL nav sets and content sets in the entire document
  const navSets = document.querySelectorAll(NAV_SET_CLASS);
  const contentSets = document.querySelectorAll(CONTENT_SET_CLASS);
  
  // Get ALL nav items and content items from the entire document
  const allNavItems = document.querySelectorAll(`${NAV_SET_CLASS} ${NAV_ITEM_CLASS}`);
  const allContentItems = document.querySelectorAll(`${CONTENT_SET_CLASS} ${CONTENT_ITEM_CLASS}`);
  
  // Skip if no items found
  if (allNavItems.length === 0 && allContentItems.length === 0) return;
  
  // Extract set numbers and sort them to ensure consistent ordering
  const getSetNumber = (element, setClass) => {
    const classList = Array.from(element.classList);
    const setClassMatch = classList.find(cls => cls.includes(setClass.replace('[class*="', '').replace('"]', '').replace('-', '-')));
    if (setClassMatch) {
      const match = setClassMatch.match(/(\d+)/);
      return match ? parseInt(match[1]) : 0;
    }
    return 0;
  };
  
  // Group sets by their numbers
  const navSetsByNumber = {};
  const contentSetsByNumber = {};
  
  navSets.forEach(set => {
    const setNumber = getSetNumber(set, 'nav-set-');
    if (!navSetsByNumber[setNumber]) navSetsByNumber[setNumber] = [];
    navSetsByNumber[setNumber].push(set);
  });
  
  contentSets.forEach(set => {
    const setNumber = getSetNumber(set, 'content-set-');
    if (!contentSetsByNumber[setNumber]) contentSetsByNumber[setNumber] = [];
    contentSetsByNumber[setNumber].push(set);
  });
  
  // Calculate items per set for each type
  const navSetNumbers = Object.keys(navSetsByNumber).map(Number).sort((a, b) => a - b);
  const contentSetNumbers = Object.keys(contentSetsByNumber).map(Number).sort((a, b) => a - b);
  
  // Count items in each set to determine items per set
  let navItemsPerSet = 0;
  let contentItemsPerSet = 0;
  
  if (navSetNumbers.length > 0) {
    const firstNavSet = navSetsByNumber[navSetNumbers[0]][0];
    navItemsPerSet = firstNavSet.querySelectorAll(NAV_ITEM_CLASS).length;
  }
  
  if (contentSetNumbers.length > 0) {
    const firstContentSet = contentSetsByNumber[contentSetNumbers[0]][0];
    contentItemsPerSet = firstContentSet.querySelectorAll(CONTENT_ITEM_CLASS).length;
  }
  
  // Determine total number of tabs
  const totalTabs = Math.max(navItemsPerSet, contentItemsPerSet);
  
  // Skip if no tabs can be determined
  if (totalTabs === 0) return;
  
  let currentIndex = 0;
  let autoplayInterval;
  let pauseTimeout;
  let isPaused = false;
  
  // Group items by their position index across ALL sets globally
  const navGroups = {};
  const contentGroups = {};
  
  // Group nav items by their position within their respective sets
  navSetNumbers.forEach(setNumber => {
    navSetsByNumber[setNumber].forEach(set => {
      const navItems = set.querySelectorAll(NAV_ITEM_CLASS);
      navItems.forEach((navItem, itemIndex) => {
        if (itemIndex < totalTabs) {
          navItem.dataset.tab = itemIndex;
          navItem.dataset.set = setNumber;
          
          if (!navGroups[itemIndex]) navGroups[itemIndex] = [];
          navGroups[itemIndex].push(navItem);
        }
      });
    });
  });
  
  // Group content items by their position within their respective sets
  contentSetNumbers.forEach(setNumber => {
    contentSetsByNumber[setNumber].forEach(set => {
      const contentItems = set.querySelectorAll(CONTENT_ITEM_CLASS);
      contentItems.forEach((contentItem, itemIndex) => {
        if (itemIndex < totalTabs) {
          contentItem.dataset.tab = itemIndex;
          contentItem.dataset.set = setNumber;
          
          if (!contentGroups[itemIndex]) contentGroups[itemIndex] = [];
          contentGroups[itemIndex].push(contentItem);
        }
      });
    });
  });
  
  const activateTab = (index) => {
    // Activate all nav items at the same index across ALL sets globally
    Object.entries(navGroups).forEach(([tabIndex, navItems]) => {
      const isActive = parseInt(tabIndex) === index;
      navItems.forEach(navItem => {
        navItem.classList.toggle(ACTIVE_CLASS, isActive);
        navItem.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    });
    
    // Activate all content items at the same index across ALL sets globally
    Object.entries(contentGroups).forEach(([tabIndex, contentItems]) => {
      const isActive = parseInt(tabIndex) === index;
      contentItems.forEach(contentItem => {
        contentItem.classList.toggle(ACTIVE_CLASS, isActive);
      });
    });
    
    currentIndex = index;
  };
  
  const startAutoplay = () => {
    if (!autoplayEnabled || isPaused) return;
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % totalTabs;
      activateTab(nextIndex);
    }, autoplayDelay);
  };
  
  const stopAutoplay = () => clearInterval(autoplayInterval);
  
  const pauseAutoplay = () => {
    if (!autoplayEnabled || !pauseOnInteraction) return;
    isPaused = true;
    stopAutoplay();
    
    clearTimeout(pauseTimeout);
    
    pauseTimeout = setTimeout(() => {
      isPaused = false;
      startAutoplay();
    }, pauseOnInteractionDelay);
  };
  
  const resumeAutoplay = () => {
    if (!autoplayEnabled || !pauseOnInteraction) return;
    clearTimeout(pauseTimeout);
    isPaused = false;
    startAutoplay();
  };
  
  // Add event listeners to ALL nav items globally
  allNavItems.forEach(navItem => {
    const tabIndex = parseInt(navItem.dataset.tab, 10);
    
    // Skip if tab index is invalid
    if (isNaN(tabIndex) || tabIndex >= totalTabs) return;
    
    navItem.setAttribute('role', 'button');
    navItem.setAttribute('tabindex', '0');
    navItem.setAttribute('aria-selected', 'false');
    
    navItem.addEventListener('click', () => {
      activateTab(tabIndex);
      if (pauseOnInteraction) pauseAutoplay();
    });
    
    navItem.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(tabIndex);
        if (pauseOnInteraction) pauseAutoplay();
      }
    });
    
    // Pause on hover/focus
    if (pauseOnInteraction) {
      navItem.addEventListener('mouseenter', pauseAutoplay);
      navItem.addEventListener('focus', pauseAutoplay);
    }
  });
  
  // Add global pause/resume when hovering over any nav or content set
  if (pauseOnInteraction) {
    const allSets = [...navSets, ...contentSets];
    allSets.forEach(set => {
      set.addEventListener('mouseenter', pauseAutoplay);
      set.addEventListener('mouseleave', () => {
        if (!isPaused) return;
        clearTimeout(pauseTimeout);
        pauseTimeout = setTimeout(() => {
          isPaused = false;
          startAutoplay();
        }, pauseOnInteractionDelay);
      });
    });
  }
  
  // Initialize - activate first tab globally
  if (totalTabs > 0) {
    activateTab(0);
    startAutoplay();
  }
  
  // Expose global control functions (optional)
  window.tabSystem = {
    activateTab,
    startAutoplay,
    stopAutoplay,
    pauseAutoplay,
    resumeAutoplay,
    getCurrentIndex: () => currentIndex,
    getTotalTabs: () => totalTabs
  };
})();


// COW

const coH7ScrollTRIGGER = '.co-home-7-cow-3';
const coH7ScrollTRIGGEREnd = '.co-about-5'
const coH7ScrollSTART = '-25% bottom';
const coH7ScrollEND = '125% top';
function getUpdatedMotionPath() {
  return {
    immediateRender: true,
    path: "#co-home-7-wave-svg-path-id",
    align: "#co-home-7-wave-svg-path-id",
    autoRotate: true,
    alignOrigin: [0.5, 0],
    start: 1,
    end: 0,
  };
}
function initializeMotionPath() {
  // gsap.set('.co-home-7-cow-1', { rotateX: 180, top: "-2vw" });
  const coHomeSection2MotionPath = getUpdatedMotionPath();
  const tl = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: 1,
    },
  });
  tl.to('.co-home-7-cow', {
    motionPath: coHomeSection2MotionPath,
  });
  const progressTimeline1 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline2 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline3 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline4 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline5 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  const progressTimeline6 = gsap.timeline({
    defaults: { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: coH7ScrollTRIGGER,
      endTrigger: coH7ScrollTRIGGEREnd,
      start: coH7ScrollSTART,
      end: coH7ScrollEND,
      scrub: true, 
      onUpdate: (self) => {
        const progressPercent = Math.round(self.progress * 100);
      }
    },
  });
  // LEG 1
  let coHome7CowFrontLeg1START = 35;
  let coHome7CowFrontLeg1END = -35;
  progressTimeline1.set('.co-home-7-cow-front-leg-1', { rotate: coHome7CowFrontLeg1START });
  for (let i = 0; i < 6; i++) {
    progressTimeline1.to('.co-home-7-cow-front-leg-1', { rotate: coHome7CowFrontLeg1END });
    progressTimeline1.to('.co-home-7-cow-front-leg-1', { rotate: coHome7CowFrontLeg1START });
  }
  // LEG 2
  let coHome7CowFrontLeg2START = -35;
  let coHome7CowFrontLeg2END = 35;
  progressTimeline2.set('.co-home-7-cow-front-leg-2', { rotate: coHome7CowFrontLeg2START });
  for (let i = 0; i < 6; i++) {
    progressTimeline2.to('.co-home-7-cow-front-leg-2', { rotate: coHome7CowFrontLeg2END });
    progressTimeline2.to('.co-home-7-cow-front-leg-2', { rotate: coHome7CowFrontLeg2START });
  }
  // LEG 3
  let coHome7CowRearLeg1START = -35;
  let coHome7CowRearLeg1END = 35;
  progressTimeline3.set('.co-home-7-cow-rear-leg-1', { rotate: coHome7CowRearLeg1START });
  for (let i = 0; i < 6; i++) {
    progressTimeline3.to('.co-home-7-cow-rear-leg-1', { rotate: coHome7CowRearLeg1END });
    progressTimeline3.to('.co-home-7-cow-rear-leg-1', { rotate: coHome7CowRearLeg1START });
  }
  // LEG 4
  let coHome7CowRearLeg2START = 35;
  let coHome7CowRearLeg2END = -35;
  progressTimeline4.set('.co-home-7-cow-rear-leg-2', { rotate: coHome7CowRearLeg2START });
  for (let i = 0; i < 6; i++) {
    progressTimeline4.to('.co-home-7-cow-rear-leg-2', { rotate: coHome7CowRearLeg2END });
    progressTimeline4.to('.co-home-7-cow-rear-leg-2', { rotate: coHome7CowRearLeg2START });
  }
  // TAIL
  let coHome7CowTailSTART = 15;
  let coHome7CowTailEND = -5;
  progressTimeline5.set('.co-home-7-cow-tail', { rotate: coHome7CowTailSTART });
  for (let i = 0; i < 9; i++) {
    progressTimeline5.to('.co-home-7-cow-tail', { rotate: coHome7CowTailEND });
    progressTimeline5.to('.co-home-7-cow-tail', { rotate: coHome7CowTailSTART });
  }
  // BODY
  let coHome7Cow2START = "-0.8vw";
  let coHome7Cow2END = "0.8vw";
  progressTimeline6.set('.co-home-7-cow-2', { y: coHome7Cow2START });
  for (let i = 0; i < 10; i++) {
    progressTimeline6.to('.co-home-7-cow-2', { y: coHome7Cow2END });
    progressTimeline6.to('.co-home-7-cow-2', { y: coHome7Cow2START });
  }
  
  ScrollTrigger.create({
    trigger: coH7ScrollTRIGGER,
    endTrigger: coH7ScrollTRIGGEREnd,
    start: coH7ScrollSTART,
    end: coH7ScrollEND,
    onUpdate: (self) => {
      self.direction === -1 ? coMotionPathFlipLeft() : coMotionPathFlipRight();
    },
  });
}

function coMotionPathFlipRight() {
  gsap.to(".co-home-7-cow-1", { rotateY: 0, duration: 0.1 });
}

function coMotionPathFlipLeft() {
  gsap.to(".co-home-7-cow-1", { rotateY: 180, duration: 0.1 });
}

initializeMotionPath();

window.addEventListener('resize', () => {
  initializeMotionPath();
  ScrollTrigger.refresh();
});